import { pushEvent } from "./utils";

/**
 * inits the delivery area data layer events
 */
const initDataLayerEvents = () => {
    document.addEventListener("dataLayer.deliveryAreaEvents", data => {
        const eventData = data?.detail;
        const deliveryAreaDetails = {
            "status": eventData?.status,
            "action": eventData?.action,
            "type": eventData?.type,
            "url": window.location.href
        };
        pushEvent("delivery_area", deliveryAreaDetails);
    });
};

module.exports = {
    initDataLayerEvents: initDataLayerEvents
};
